import { fetchCurrentUser } from '../../ducks/user.duck';
import { getSpecificUserGPTS } from '../../util/api';
import { parse } from '../../util/urlHelpers';
import {
  fetchSpaceList,
  getSpaceDetails,
  toggleCreateComment,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import { fetchGroupFolder } from '../MyGroupCommunityPage/MyGroupCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/JoinedGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/JoinedGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/JoinedGroupPage/ERROR_SPACE_DETAILS';

export const SUCCESS_FECTH_GPTS = 'app/JoinedGroupPage/SUCCESS_FECTH_GPTS';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,

  gptsDetails: null
};

export default function joinedGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

      case SUCCESS_FECTH_GPTS:
      return { ...state, gptsDetails: payload };

    default:
      return state;
  }
}

export const requestSpaceDetails = () => ({
  type: REQUEST_SPACE_DETAILS,
});
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const successFetchGpts = data => ({
  type: SUCCESS_FECTH_GPTS,
  payload:  data ,
});

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { page = 1, sort = "latest" } = parse(search);
  const { currentUser } = getState().user;
  const { spaceListData } = getState().CircleCommunityPage;

  const promises = [];

  // ✅ Fetch current user if not available
  if (!currentUser) {
    promises.push(dispatch(fetchCurrentUser()).catch((e) => console.log(e, "Error fetching current user")));
  }

  // ✅ Fetch Space Details & Handle Response
  const spaceDetailsPromise = dispatch(getSpaceDetails({ spaceId: params.id, page: +page, sort }))
    .then((spaceDetailsData) => {
      console.log("✅ Space Details Response:", spaceDetailsData);
      const { spaceDetail } = spaceDetailsData || {};
      const { id: group_id, file_id = "file_id" } = spaceDetail || {};
      getSpecificUserGPTS({ group_id, file_id }).then((response) => {
        console.log(response, "response");
        dispatch(successFetchGpts(response.gpts));

      }).catch(error => {
        console.log(error, "error")

      })
      return spaceDetailsData;
    })
    .catch((error) => {
      console.error("❌ Error fetching space details:", error);
    });

  promises.push(spaceDetailsPromise);

  // ✅ Fetch Group Folder
  promises.push(
    dispatch(
      fetchGroupFolder({
        payload: {
          groupId: params.id,
          isActive: true,
          isDelete: false,
        },
      })
    )
  );

  // ✅ Fetch Space List if necessary
  if (!spaceListData || spaceListData.length === 0) {
    promises.push(dispatch(fetchSpaceList()));
  }

  // ✅ Toggle Comment (No need to wait)
  dispatch(toggleCreateComment(false));

  // ✅ Return all promises
  return Promise.all(promises);
};

